import type { RolUsuario } from '@tms/contratos';

/** Crear, editar, marcar por defecto y dar de baja rutas; cambiar la ruta de un viaje (ruteo.ts). */
export const puedeEditarRutas = (rol: RolUsuario | undefined): boolean => rol === 'DESPACHO' || rol === 'ADMIN';

/** Editar reglas de alerta (reglas-alerta.ts: ADMIN). */
export const puedeEditarReglas = (rol: RolUsuario | undefined): boolean => rol === 'ADMIN';

/** Ver y editar la configuración de alertas: solo ADMIN (GET /configuracion/reglas-alerta devuelve 403 al resto). */
export const puedeVerReglas = (rol: RolUsuario | undefined): boolean => rol === 'ADMIN';
